import { STOVA_RS, STOVA_US } from '../constants/common'

export function isStovaOverrideFunction(overrideFunction: string): boolean {
  return overrideFunction.includes(STOVA_RS) && overrideFunction.includes(STOVA_US)
}

export function buildStovaOverrideFunction(eventId: string): string {
  return `{RegistrationId}${STOVA_RS}${eventId}${STOVA_US}{FirstName}${STOVA_US}{LastName}${STOVA_US}{Company}${STOVA_US}`
}

export function parseStovaEventId(overrideFunction: string): string {
  const match = overrideFunction.match(new RegExp(`${STOVA_RS}([^${STOVA_US}]*)${STOVA_US}`))
  return match?.[1] ?? ''
}

export function formatStovaOverrideForDisplay(overrideFunction: string): string {
  return overrideFunction.replaceAll(STOVA_RS, '[RS]').replaceAll(STOVA_US, '[US]')
}

export function generateStovaFromOverrideFunction(overrideFunction: string, record?: Record<string, string>): string {
  if (!record) {
    return overrideFunction
  }

  return overrideFunction.replace(/\{([^}]+)\}/g, (_, fieldName: string) => record[fieldName] ?? '')
}
